import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { ProductCard } from '../product/ProductCard';
import { CarouselControls } from './CarouselControls';
import { useCarousel } from '../../hooks/useCarousel';
import { products } from '../../data/products';
export function BestSellers() {
  const {
    ref,
    canPrev,
    canNext,
    scroll
  } = useCarousel<HTMLUListElement>();
  const top = [...products].sort((a, b) => b.reviews - a.reviews).slice(0, 10);
  return <section aria-labelledby="bestsellers-heading" className="bg-surface py-14 lg:py-20" data-id="element-70" data-mp="87jv9t7aoeby">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-71" data-mp="m71dfpq34tcc">
        <div className="flex items-end justify-between gap-4" data-id="element-72" data-mp="m46rtuvc52hc">
          <div data-id="element-73" data-mp="i451uiyypxhw">
            <h2 id="bestsellers-heading" className="text-2xl font-bold tracking-tight text-ink sm:text-[32px]" data-id="element-74" data-mp="i3muaq6unwuo">
              Onze hardlopers
            </h2>
            <p className="mt-1.5 text-[15px] text-muted" data-id="element-75" data-mp="1tkv09fx59l0y">Wat klanten nu het vaakst bestellen.</p>
          </div>
          <div className="flex items-center gap-4" data-id="element-76" data-mp="2dxfa12s2ozvm">
            <Link to="/shop" className="hidden items-center gap-1 text-sm font-semibold text-ink hover:underline sm:inline-flex" data-id="element-77" data-mp="2ixjq4rp2jslb">
              Bekijk alles <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-78" data-mp="2n082h9czrhn1" />
            </Link>
            <CarouselControls canPrev={canPrev} canNext={canNext} onPrev={() => scroll(-1)} onNext={() => scroll(1)} label="producten" data-id="element-79" data-mp="2ryhyfm6jim9p" />
          </div>
        </div>

        <ul ref={ref} className="-mx-4 mt-7 flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-px-4 px-4 pb-2 [scrollbar-width:none] sm:mx-0 sm:scroll-px-0 sm:gap-4 sm:px-0 lg:gap-5 [&::-webkit-scrollbar]:hidden" data-id="element-80" data-mp="1z9kezfqlejfd">
          {top.map(p => <li key={p.id} className="w-[70%] shrink-0 snap-start sm:w-[calc((100%-1rem)/2)] md:w-[calc((100%-2rem)/3)] lg:w-[calc((100%-3.75rem)/4)]" data-id="element-81" data-mp="291goro21jxzf">
              <ProductCard product={p} data-id="element-82" data-mp="1gib34ztcnikm" />
            </li>)}
        </ul>
      </div>
    </section>;
}